import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import Link from "next/link";
import PopularVehiclesTable from "../../modules/Vehicles/PopularVehiclesTable";

const AtfContentSection = ({
  content,
  tableData = null, // { heading, vehiclesData }
  collapsedHeight = { xs: "96px", md: "51px" }, // Default collapsed height
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // Handle different content formats
  const renderContent = () => {
    // If content is a string (simple text)
    if (typeof content === "string") {
      return (
        <Typography
          variant="body1"
          sx={{
            marginBottom: "10px",
            fontSize: { xs: "12px", md: "16px" },
            fontWeight: 400,
            color: "#000",
            lineHeight: 1.6,
          }}
        >
          {content}
        </Typography>
      );
    }

    // If content is an object with text array and automakers
    if (content?.text && Array.isArray(content.text)) {
      return (
        <>
          {content.text.map((text, index) => {
            // Skip text[3] as it's used as a separator
            if (index === 3) return null;

            // Handle text[2] which contains automakers links
            if (index === 2) {
              return (
                <Typography
                  key={index}
                  variant="body1"
                  sx={{
                    marginBottom: "10px",
                    fontSize: { xs: "12px", md: "16px" },
                    fontWeight: 400,
                    color: "#000",
                    lineHeight: 1.6,
                  }}
                >
                  {content.text[2]}
                  {content.automakers?.map((automaker, automakerIndex) => (
                    <span key={automaker.name}>
                      <Link
                        href={automaker.link}
                        style={{
                          color: "#024670",
                          textDecoration: "none",
                          fontWeight: 600,
                          borderBottom: "1px solid #024670",
                        }}
                      >
                        {automaker.name}
                      </Link>
                      {automakerIndex < content.automakers.length - 2
                        ? ", "
                        : automakerIndex === content.automakers.length - 2
                        ? content.text[3]
                        : ""}
                    </span>
                  ))}
                  {content.text[4]}
                </Typography>
              );
            }

            // Regular text paragraphs
            return (
              <React.Fragment key={index}>
                {index === 1 && <br />}
                <Typography
                  variant="body1"
                  sx={{
                    marginBottom: index < content.text.length - 1 ? "10px" : "0",
                    fontSize: { xs: "12px", md: "16px" },
                    fontWeight: 400,
                    color: "#000",
                    lineHeight: 1.6,
                  }}
                >
                  {text}
                </Typography>
              </React.Fragment>
            );
          })}
        </>
      );
    }

    // If content is an array of strings
    if (Array.isArray(content)) {
      return content.map((text, index) => (
        <Typography
          key={index}
          variant="body1"
          sx={{
            marginBottom: "10px",
            fontSize: { xs: "12px", md: "16px" },
            fontWeight: 400,
            color: "#000",
            lineHeight: 1.6,
          }}
        >
          {text}
        </Typography>
      ));
    }

    return null;
  };

  return (
    <Box
      sx={{
        width: { xs: "100%", md: "84%" },
        margin: "20px auto",
        padding: { xs: "0 12px", md: "0" },
      }}
    >
      <Box
        sx={{
          maxHeight: isExpanded ? "none" : collapsedHeight,
          overflow: "hidden",
          position: "relative",
        }}
      >
        {renderContent()}

        {tableData && (
          <Box
            sx={{
              marginTop: "20px",
              display: isExpanded ? "block" : "none",
            }}
          >
            <PopularVehiclesTable
              heading={tableData.heading}
              vehiclesData={tableData.vehiclesData}
              inline={true}
            />
          </Box>
        )}
      </Box>

      <Typography
        onClick={() => setIsExpanded(!isExpanded)}
        sx={{
          marginTop: "10px",
          color: "#024670",
          fontSize: { xs: "12px", md: "14px" },
          fontWeight: "bold",
          cursor: "pointer",
          display: "inline-block",
          "&:hover": {
            textDecoration: "underline",
          },
        }}
      >
        {isExpanded ? "Read Less" : "Read More"}
      </Typography>
    </Box>
  );
};

export default AtfContentSection;

